import React from 'react';

const AcceptedCreditCards = ({ isUkClient }) => {
	if (isUkClient) {
		return <>We accept MasterCard or Visa.</>;
	}
	return <>We accept American Express, MasterCard, Visa, or Discover cards.</>;
};

export default AcceptedCreditCards;
